<template>
  <div class="operation-list">
    <template v-for="op in currentOperationList">
      <button
        v-if="!hiddenItems[op.icon]"
        :key="op.name + op.icon"
        type="button"
        :class="[
          'operation-button',
          { 'operation-button-active': currentIcon === op.icon }
        ]"
        @click="handleClick(op.icon)"
      >
        <template v-if="op.name === '字幕'">
          <el-tooltip
            class="item"
            effect="dark"
            content="字幕重叠或超出，请检查"
            placement="right"
            :disabled="!isSubtitlesOverlap"
          >
            <div>
              <div style="display: flex;justify-content: center;">
                <img
                  :src="'/preview/icon/' + op.icon + '.png'"
                  :alt="op.name"
                  style="width: 16px;height:16px"
                >
                <div
                  v-if="isSubtitlesOverlap"
                  style="margin-left:2px;margin-right:-13px;height: 16px;line-height: 1;"
                >
                  <i
                    class="el-icon-warning"
                    style="color: #f56c6c;font-size: 16px"
                  />
                </div>
              </div>
              <div class="name">
                {{ op.name }}
              </div>
            </div>
          </el-tooltip>
        </template>
        <div v-else>
          <img
            :src="'/preview/icon/' + op.icon + '.png'"
            :alt="op.name"
          >
          <div class="name">
            {{ op.name }}
          </div>
        </div>
      </button>
    </template>
    <a
      v-if="!isFisher"
      class="helps"
      href="/help?tab=4&menu_id=23&submenu_id=24"
      target="_blank"
    >
      <img
        src="/preview/icon/help.png"
        alt="help"
      >
      帮助
    </a>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import _ from 'lodash'

const menuMap = {
  snippet: 'VideoClipList',
  music: 'MusicMenu',
  text: 'TextMenu',
  material: 'MaterialMenu',
  stamp: 'StampMenu',
  subtitle: 'VideoClipList',
  style: 'StyleMenu',
  shape: 'ShapeMenu',
  template: 'TemplateMenu',
  mine: 'MineMenu',
  videoscript: 'VideoClipList',
  figure: 'FigureMenu',
  figureTemplate: 'figureTemplateMenu'
}

const infoMap = {
  snippet: 'VideoFormat',
  music: 'BackgroundAudioFormat',
  text: 'VideoFormat',
  image: 'VideoFormat',
  material: 'VideoFormat',
  stamp: 'ImageStampInfo',
  subtitle: 'VideoFormat',
  shape: 'VideoFormat',
  template: 'VideoFormat',
  mine: 'VideoFormat',
  videoscript: 'VideoFormat'
}

const typeMap = {
  video: { menu: 'MaterialMenu', submenu: 'VideoMaterialInfo', icon: 'material' },
  image: { menu: 'MaterialMenu', submenu: 'MaterialInfo', icon: 'material' },
  sticker: { menu: 'MaterialMenu', submenu: 'StickerInfo', icon: 'material' },
  lottie: { menu: 'MaterialMenu', submenu: 'LottieInfo', icon: 'material' },
  icon: { menu: 'MaterialMenu', submenu: 'IconFormat', icon: 'material' },
  text: { menu: 'TextMenu', submenu: 'TextFormat', icon: 'text' },
  shape: { menu: 'ShapeMenu', submenu: 'ShapeFormat', icon: 'shape' },
  container: { menu: 'ShapeMenu', submenu: 'ContainerFormat', icon: 'shape' },
  textContainer: { menu: 'ShapeMenu', submenu: 'TextContainerFormat', icon: 'shape' },
  group: { menu: 'ShapeMenu', submenu: 'GroupFormat', icon: 'shape' },
  wordArt: { menu: 'TextMenu', submenu: 'WordArtFormat', icon: 'text' }
}

export default {
  name: 'OperationList',
  data () {
    return {
      operationList: [
        { name: '片段', icon: 'snippet' },
        { name: '模板', icon: 'template' },
        { name: '音乐', icon: 'music' },
        { name: '文本', icon: 'text' },
        { name: '素材', icon: 'material' },
        { name: '形状', icon: 'shape' },
        { name: '水印', icon: 'stamp' },
        { name: '字幕', icon: 'subtitle' },
        { name: '脚本', icon: 'videoscript' },
        { name: '我的', icon: 'mine' }
      ]
    }
  },
  computed: {
    ...mapState([
      'isFisher',
      'fisherInfo',
      'currentIcon',
      'selectedTrackId',
      'selectedAudioId',
      'userMeal'
    ]),
    ...mapGetters(['currentEffect', 'selectedEffectId', 'intersectingTracks']),
    currentOperationList () {
      if (this.isFisher) {
        if (this.fisherInfo && this.fisherInfo?.type === 'digitalHuman') {
          return [
            { name: '数字人', icon: 'figure' },
            // { name: '片段', icon: 'snippet' },
            { name: '模板', icon: 'figureTemplate' },
            // { name: '模板', icon: 'template' },
            { name: '音乐', icon: 'music' },
            { name: '文本', icon: 'text' },
            { name: '素材', icon: 'material' },
            { name: '形状', icon: 'shape' },
            { name: '水印', icon: 'stamp' },
            { name: '字幕', icon: 'subtitle' }
          ]
        }
        return [
          { name: '片段', icon: 'snippet' },
          { name: '模板', icon: 'template' },
          { name: '音乐', icon: 'music' },
          { name: '文本', icon: 'text' },
          { name: '素材', icon: 'material' },
          { name: '形状', icon: 'shape' },
          { name: '水印', icon: 'stamp' },
          { name: '字幕', icon: 'subtitle' }
        ]
      }
      return this.operationList
    },
    selection () {
      const ret = []
      if (this.currentEffect.type) {
        ret.push('effect:' + this.selectedEffectId + this.currentEffect.type)
      }
      if (this.selectedTrackId) {
        ret.push('track:' + this.selectedTrackId)
      }
      if (this.selectedAudioId) {
        ret.push('audio:' + this.selectedAudioId)
      }
      return ret.join('!')
    },
    hiddenItems () {
      if (this.userMeal) {
        const allowStamp = +this.userMeal[2].lower[16].value !== 3
        const allowSubtitle = '48' in this.userMeal[2].lower
          ? +this.userMeal[2].lower[48].value !== 3
          : true
        return {
          stamp: !allowStamp,
          subtitle: !allowSubtitle
        }
      }
      return {
        stamp: 1,
        subtitle: 1
      }
    },
    isSubtitlesOverlap () {
      return !_.isEmpty(this.intersectingTracks)
    }
  },
  watch: {
    selection (cur, prev) {
      const { type } = this.currentEffect
      this.handleFilterShowing(false)
      this.handleKeyboardShortcutShow(false)

      const curSelection = {
        effect: '',
        track: '',
        audio: ''
      }

      const prevSelection = {
        effect: '',
        track: '',
        audio: ''
      }

      cur.replace(/(effect|track|audio):[^!]+/g, (s, cap) => {
        curSelection[cap] = s
      })

      prev.replace(/(effect|track|audio):[^!]+/g, (s, cap) => {
        prevSelection[cap] = s
      })

      console.log(curSelection)

      if (!this.lock) {
        if (curSelection.effect !== prevSelection.effect) {
          if (!type) {
            this.handleCurrentSubmenu('VideoFormat')
          } else {
            const { menu = '', submenu = '', icon = '' } = typeMap[type] || {}
            if (menu && submenu && icon) {
              this.handleCurrentSubmenu(submenu)
            }
            this.handleAudioSelect(null)
          }
        }
        if (curSelection.track !== prevSelection.track) {
          if (this.selectedTrackId) {
            this.handleAudioSelect(null)
          }
          if (type) {
            this.handleEffectSelect([])
          }
        }
        if (curSelection.audio !== prevSelection.audio) {
          if (this.selectedAudioId) {
            this.handleEffectSelect([])
            this.handleTrackSelect(null)
          }
        }
      }
    }
  },
  methods: {
    ...mapMutations([
      'handleCurrentIcon',
      'handleCurrentMenu',
      'handleCurrentSubmenu',
      'handleEffectSelect',
      'handleContainerEdit',
      'handleFilterShowing',
      'handleKeyboardShortcutShow',
      'handleAudioSelect',
      'handleTrackSelect',
      'handleMenuCollapse'
    ]),
    handleClick (icon) {
      if (icon == 'stamp' && this.userMeal[2].lower[16].value != 1) {
        this.$store.commit('handleMealDialogVisible', true)
        return
      }
      this.lock = true
      this.handleCurrentIcon(icon)
      this.handleCurrentMenu(menuMap[icon])
      this.handleCurrentSubmenu(infoMap[icon])
      this.handleEffectSelect([])
      this.handleContainerEdit(null)
      this.handleKeyboardShortcutShow(false)
      this.handleAudioSelect(null)
      this.handleTrackSelect(null)
      if (icon !== 'subtitle' && icon !== 'videoscript') {
        this.handleMenuCollapse(false)
      }
      setTimeout(() => {
        this.lock = false
      }, 20)
    }
  },
  mounted () {
    if (this.isFisher && this.fisherInfo?.type === 'digitalHuman') {
      this.handleCurrentIcon(this.currentOperationList[0].icon)
      this.handleCurrentMenu(menuMap[this.currentOperationList[0].icon])
      this.handleCurrentSubmenu(infoMap[this.currentOperationList[0].icon])
      this.lock = false
    }
  }
}
</script>

<style scoped>
.operation-list {
  width: 60px;
  background: #202d3d;
  position: relative;
  z-index: 3;
}

.operation-button {
  width: 60px;
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  flex-direction: column;
  color: rgba(255, 255, 255, 0.55);
  transition: 0.3s;
  padding: 14px 0 12px;
  outline: 0;
  border: 0;
  border-radius: 0;
  background-color: transparent;
  position: relative;
}
.operation-button img {
  max-width: 16px;
}

.operation-button:hover,
.operation-button:focus {
  color: #fff;
  background: rgba(255, 255, 255, 0.12);
}

.operation-button-active {
  background: #007eff;
  color: #fff;
}

.operation-button-active:hover,
.operation-button-active:focus {
  background: #1088ff;
}

.name {
  margin-top: 4px;
  line-height: 1.25;
}
.helps {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  color: #fff;
  font-size: 12px;
  text-align: center;
}
.helps img {
  width: 16px;
  height: 16px;
  margin-right: 6px;
}

@media screen and (max-height: 710px) {
  .operation-button {
    color: #fff;
    padding: 8px 0 12px;
    height: 40px;
  }
  .operation-button img {
    display: none;
  }
}
</style>
